import React from 'react'
import dynamic from 'next/dynamic'

// mobile mega menu should not be SSR, as burger still appears.
const MobileMegaMenu = dynamic(
    () => import('./components/MobileMegaMenu/MobileMegaMenu')
)

// Should be ssr to make sure that links are visible to users initially
const DesktopMegaMenu = dynamic(
    () => import('./components/DesktopMegaMenu/DesktopMegaMenu')
)

import cn from 'classnames'
import s from '@commonStyles/menus/MegaMenu.module.scss'
import { useNavMenu, useModal } from './hooks'
import { usePreloadedData } from 'preload'
import { useTranslation } from 'next-i18next'
import { useStoreConfig } from 'config'

export const MegaMenu = ({
    className,
    showCurrency,
    handleChatOpen
}: {
    className: string
    showCurrency?: boolean
    handleChatOpen: () => void
}): JSX.Element | null => {
    const [isOpen, setIsOpen] = useModal(false)
    const config = useStoreConfig()
    const variables = config.preload.menu?.variables
    const preloadedMenuData = usePreloadedData('menu')
    const { navigation: navigationData } = useNavMenu(
        { ...variables, onlyTopLevel: false },
        {
            initialData: preloadedMenuData,
            revalidateOnMount: true,
            revalidateOnFocus: false
        }
    )

    const { t } = useTranslation('common')

    const renderBurger = () => {
        return (
            <div
                className={cn(s.burgerIcon, { [s.activeBurger]: isOpen })}
                onClick={() => setIsOpen(!isOpen)}
                aria-hidden="true"
            >
                <span />
                <span />
                <span data-content="menu" />
            </div>
        )
    }

    return variables?.category_uid && navigationData ? (
        <div className={cn(className, s.megaMenuCms)}>
            {renderBurger()}
            <MobileMegaMenu
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                navData={navigationData}
                showCurrency={showCurrency}
                handleChatOpen={handleChatOpen}
            />
            <DesktopMegaMenu navData={navigationData} />
        </div>
    ) : (
        <span>{t('Failed to load navigation menu')}</span>
    )
}
